var map = {
	"./IMG_1_INAUGURACAO.png": 5712,
	"./IMG_2_INAUGURACAO.png": 4683,
	"./IMG_3_INAUGURACAO.png": 30,
	"./IMG_4_INAUGURACAO.png": 5185,
	"./IMG_5_INAUGURACAO.png": 4420,
	"./IMG_6_INAUGURACAO.png": 8831,
	"./IMG_7_INAUGURACAO.png": 9394,
	"./IMG_8_INAUGURACAO.png": 8085,
	"./IMG_9_INAUGURACAO.png": 5368,
	"./IMG_ABRE_INAUGURACAO.png": 5559,
	"./IMG_NEXT_INAUGURACAO.png": 6582
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3858;